module.exports = __webpack_public_path__ + "sounds/5215f71ee56539f14f280d518e970800.mp3";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/sounds/good.mp3
// module id = 87
// module chunks = 0